// extracted by mini-css-extract-plugin
export default {"title":"_4a784b6e6e","inner_title":"_5840e6406b","charge_btn":"a820e4cc78"};